import ApiClient from '@/libs/http-client'

const UsersService = {
    endpoints(route, param) {
        const url = {
            getActiveUsers: '/api/users?active=1',
            changeDateOfBirth: `/api/users/${param}`,
            changePassword: '/api/users/password/reset',
            updateProfileData: '/api/users',
            addClient: '/api/clients',
            editProfileData: `/api/users/${param}`,
            getAllUsers: '/api/users',
            getCurrentClient: `/api/clients/${param}`,
            onboardUser: '/api/users/onboard',
            offboardUser: '/api/users/offboard',
            getUsers: '/api/users?active=1&roles[]=user&roles[]=HR',
            getCurrentEmployees: '/api/users',
            getCurrentClients: '/api/clients',
            getUserClients: `/api/users?role_id=2&author_id=${param}`,
        }
        return url[route]
    },
    get(url, param = {}, config = {}) {
        return ApiClient.get(this.endpoints(url, param), config)
    },
    put(url, params = {}, data, config = {}) {
        return ApiClient.put(this.endpoints(url, params), data, config)
    },
    post(url, params = {}, data, config = {}) {
        return ApiClient.post(this.endpoints(url, params), data, config)
    },
    patch(url, params = {}, data, config = {}) {
        return ApiClient.patch(this.endpoints(url, params), data, config)
    },
    delete(url, params = {}, config = {}) {
        return ApiClient.delete(this.endpoints(url, params), config)
    },
    postFile(url, params = {}, data, config = {}) {
        config = {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data',
            },
            ...config,
        }
        return ApiClient.post(this.endpoints(url, params), data, config)
    },
    getUsers(config) {
        return this.get('getUsers', {}, config)
    },
    changeDateOfBirth(id, data, config) {
        return this.put('changeDateOfBirth', id, data, config)
    },
    changeNotOwnUserData(id, data, config) {
        return this.put('editProfileData', id, data, config)
    },
    changeClientData(id, data, config) {
        return this.put('editProfileData', id, data, config)
    },
    addNewUser(data, config) {
        return this.put('updateProfileData', {}, data, config)
    },
    getUserClients(id, config) {
        return this.get('getUserClients', id, config)
    },
    getCurrentEmployees(config) {
        return this.get('getCurrentEmployees', {}, config)
    },
    getCurrentClients(config) {
        return this.get('getCurrentClients', {}, config)
    },
    getUserRoles(config) {
        return ApiClient.get('/api/roles', config)
    },
}

export default UsersService
